import React, { useMemo} from 'react';
import styles from './Presentations.module.scss';
import { Content } from '@types';
import { Quiz, LastVisitedLessonContentFragment } from '@api/graphql-codegen';
import QuizSection from '@src/components/program-details/lesson/lesson-section/QuizSection';

type Props = {
  contents: Content[] | undefined;
  quiz: Quiz | undefined;
  lessonOpened: boolean;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
};

function Presentations(props: Props) {
  const { contents = [], lessonOpened, quiz, lastVisitedLesson, closeNav } = props;

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (lessonOpened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [lessonOpened]);
  
  return (
    <div className={wrapperClassName}>
      <div className={styles.content}>
        <QuizSection title={quiz?.name || ""} quiz={quiz} contents={contents} lastVisitedLesson={lastVisitedLesson} closeNav={closeNav} />
      </div>
    </div>
  );
}

export default React.memo(Presentations);
